/* Bluebells - multi-quantity flavour picker
   Companion to bluebells-cvp-flavour-grid.css. Three jobs, all display only:
     1. mark the grid so the stylesheet applies,
     2. lift "GLUTEN FREE - ", "VEGAN - " and friends out of the option name
        onto a smaller line under it, so every name fits two lines,
     3. ask Shopify for a sharper image than the 90px one the CVP requests,
     4. flag a card that has a quantity so it can take the selected outline.
   The radio/number input values, and therefore the cart line properties and
   everything downstream of them, are never touched. */
(function () {
  'use strict';

  /* longest first - "GLUTEN FREE & DAIRY FREE" must beat "GLUTEN FREE" */
  var DIETS = [
    [/^\s*GLUTEN\s*FREE\s*(&|AND)\s*DAIRY\s*FREE\s*[-–—:]?\s*/i, 'Gluten free \u0026 dairy free'],
    [/^\s*DAIRY\s*FREE\s*(&|AND)\s*GLUTEN\s*FREE\s*[-–—:]?\s*/i, 'Gluten free \u0026 dairy free'],
    [/^\s*GLUTEN\s*FREE\s*[-–—:]?\s*/i, 'Gluten free'],
    [/^\s*DAIRY\s*FREE\s*[-–—:]?\s*/i, 'Dairy free'],
    [/^\s*VEGAN\s*[-–—:]?\s*/i, 'Vegan'],
    [/^\s*EGGLESS\s*[-–—:]?\s*/i, 'Egg free']
  ];

  function badgeFor(name) {
    for (var i = 0; i < DIETS.length; i++) {
      if (DIETS[i][0].test(name)) {
        return { label: DIETS[i][1], rest: name.replace(DIETS[i][0], '').trim() };
      }
    }
    return null;
  }

  /* The CVP asks Shopify for a 90px image and we now show it at ~135px CSS
     (270px on a retina screen), so it arrives soft. Same image, bigger crop. */
  function sharpen(item) {
    var img = item.querySelector('.atlas-cvp__table-thumb img');
    if (!img || img.getAttribute('data-bb-sharp')) return;
    var src = img.getAttribute('src') || '';
    if (!/cdn\.shopify\.com/.test(src)) return;
    var big = /[?&]width=\d+/.test(src)
      ? src.replace(/([?&]width=)\d+/, '$1400')
      : src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=400';
    if (big === src) return;
    img.setAttribute('data-bb-sharp', '1');
    img.setAttribute('src', big);
  }

  /* IMPORTANT: the CVP reads .atlas-cvp__multiqty-title's own textContent when
     it builds the "Cupcake Flavours" cart property, which is what the job
     sheets, the print pipeline and the dashboard all read. So that element is
     left holding its original text, character for character, and only hidden
     from view. The two-line version the customer sees is a separate element
     beside it. */
  function dressItem(item) {
    var title = item.querySelector('.atlas-cvp__multiqty-title');
    if (!title || title.getAttribute('data-bb-diet')) return;
    var head = item.querySelector('.atlas-cvp__multiqty-head') || item;

    var full = (title.textContent || '').trim();
    var hit = badgeFor(full);

    title.setAttribute('data-bb-diet', '1');
    title.classList.add('bb-src');

    var wrap = document.createElement('div');
    wrap.className = 'bb-label';
    wrap.setAttribute('aria-hidden', 'true');

    var n = document.createElement('span');
    n.className = 'bb-name';
    var d = document.createElement('span');
    d.className = 'bb-diet';

    /* a name that is nothing but the dietary words keeps its full text */
    if (hit && hit.rest) {
      n.textContent = hit.rest;
      d.textContent = hit.label;
    } else {
      n.textContent = full;
      d.textContent = '';
    }

    wrap.appendChild(n);
    wrap.appendChild(d);
    head.appendChild(wrap);
  }

  function markChosen(item) {
    var inp = item.querySelector('.cvp-qty-input');
    var n = inp ? parseInt(inp.value, 10) : 0;
    item.classList.toggle('bb-has', n > 0);
  }

  /* Cap the grid at two whole rows, but only once there is a third row to
     scroll to - otherwise a short list gets a scrollbar and a row sliced in
     half for no reason. Measured from the real cards so it follows whatever
     the column width makes of them. */
  var ROWS_BEFORE_SCROLL = 2;
  function capHeight(grid) {
    var items = grid.querySelectorAll('.atlas-cvp__multiqty-item');
    if (!items.length) return;
    var tops = [];
    for (var i = 0; i < items.length; i++) {
      var t = items[i].offsetTop;
      if (tops.indexOf(t) === -1) tops.push(t);
    }
    if (tops.length <= ROWS_BEFORE_SCROLL) {
      grid.classList.remove('bb-scroll');
      grid.style.maxHeight = '';
      return;
    }
    tops.sort(function (a, b) { return a - b; });
    /* the top of the row after the last visible one, less the gap above it */
    var gap = parseFloat(getComputedStyle(grid).rowGap) || 0;
    var h = Math.round(tops[ROWS_BEFORE_SCROLL] - tops[0] - gap);
    if (!(h > 0)) return;
    grid.classList.add('bb-scroll');
    grid.style.maxHeight = h + 'px';
  }

  function run() {
    var grids = document.querySelectorAll('.atlas-cvp__multiqty-grid');
    for (var g = 0; g < grids.length; g++) grids[g].classList.add('bb-fgrid');
    var items = document.querySelectorAll('.atlas-cvp__multiqty-item');
    for (var i = 0; i < items.length; i++) {
      dressItem(items[i]);
      sharpen(items[i]);
      markChosen(items[i]);
    }
    for (var c = 0; c < grids.length; c++) capHeight(grids[c]);
  }

  function boot() {
    run();
    /* the steppers are the CVP's own custom element - watch the values
       rather than wiring into its internals */
    document.addEventListener('input', function (e) {
      var item = e.target && e.target.closest && e.target.closest('.atlas-cvp__multiqty-item');
      if (item) markChosen(item);
    }, true);
    document.addEventListener('click', function (e) {
      var item = e.target && e.target.closest && e.target.closest('.atlas-cvp__multiqty-item');
      if (item) setTimeout(function () { markChosen(item); }, 60);
    }, true);

    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; run(); }, 120);
    }).observe(document.body, { childList: true, subtree: true });

    var n = 0;
    var iv = setInterval(function () { run(); if (++n > 20) clearInterval(iv); }, 500);

    var rz;
    window.addEventListener('resize', function () {
      clearTimeout(rz);
      rz = setTimeout(function () {
        var grids = document.querySelectorAll('.atlas-cvp__multiqty-grid');
        for (var i = 0; i < grids.length; i++) {
          grids[i].style.maxHeight = '';
          grids[i].classList.remove('bb-scroll');
          capHeight(grids[i]);
        }
      }, 200);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
